import base64UrlEncode from 'hero-utils/base64UrlEncode';
const genHash = (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    return window.crypto.subtle.digest('SHA-256', data);
};
const genEncodedHash = async (str) => {
    const hash = await genHash(str);
    const stringified = String.fromCharCode.apply(null, new Uint8Array(hash));
    return base64UrlEncode(stringified);
};
export default genEncodedHash;
//# sourceMappingURL=genEncodedHash.js.map